<script setup>
import BannerTable from '@frontJs/components/tables/projectManagement/sem/BannerTable.vue';
import TenantReportBannerTable from '@frontJs/components/tables/projectManagement/sem/tenantReports/BannerTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Bannières - SEM - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEM - Bannières
    </PageTitle>

    <BannerTable v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            all: {
                title: 'Tous',
                content: h(BannerTable, { all: true }),
            },
            perCustomer: {
                title: 'Par client (objectif)',
                content: h(TenantReportBannerTable),
            },
        }"
    />
</template>
